import { PAGINATION_STORAGE_PREFIXES, PERSISTENT_LOCAL_STORAGE_PREFIXES } from '../constants/common';

/**
 * clearPaginationStorage() - Removes saved grid pagination from localStorage
 */
export function clearPaginationStorage(): void {
  for (let index = localStorage.length - 1; index >= 0; index--) {
    const key = localStorage.key(index);

    if (key && PAGINATION_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
      localStorage.removeItem(key);
    }
  }
}

/**
 * getPersistentLocalStorageEntries() - Collects localStorage entries that should survive logout
 */
export function getPersistentLocalStorageEntries(): Record<string, string> {
  const entries: Record<string, string> = {};

  for (let index = 0; index < localStorage.length; index++) {
    const key = localStorage.key(index);

    if (key && PERSISTENT_LOCAL_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
      const value = localStorage.getItem(key);
      if (value !== null) {
        entries[key] = value;
      }
    }
  }

  return entries;
}

/**
 * restorePersistentLocalStorageEntries() - Restores preserved localStorage entries
 */
export function restorePersistentLocalStorageEntries(entries: Record<string, string>): void {
  Object.entries(entries).forEach(([key, value]) => localStorage.setItem(key, value));
}

/**
 * clearLocalStoragePreservingUserPreferences() - Clears session localStorage on logout
 */
export function clearLocalStoragePreservingUserPreferences(): void {
  clearPaginationStorage();
  const preservedEntries = getPersistentLocalStorageEntries();
  localStorage.clear();
  restorePersistentLocalStorageEntries(preservedEntries);
}
